/* eslint-disable max-classes-per-file */
import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class CollectorGeometryHoverMessage extends BasicEvent {
    collectorGeometryId: any;
    hoverIn: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CollectorGeometryHoverMessage";
    constructor(collectorGeometryId: any, hoverIn: boolean) {
        super(CollectorGeometryHoverMessage.$type);
        this.collectorGeometryId = collectorGeometryId;
        this.hoverIn = hoverIn;
    }
}

export class CollectorListHoverMessage extends BasicEvent {
    collectorGeometryId: any;
    hoverIn: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CollectorListHoverMessage";
    constructor(collectorGeometryId: any, hoverIn: boolean) {
        super(CollectorListHoverMessage.$type);
        this.collectorGeometryId = collectorGeometryId;
        this.hoverIn = hoverIn;
    }
}

export class CollectorCancelMessage extends BasicEvent {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CollectorCancelMessage";
    constructor() {
        super(CollectorCancelMessage.$type);
    }
}
